import OnboardingLoading from "./OnboardingLoading";

export default OnboardingLoading;
